module.exports = __webpack_public_path__ + "img/create.74c1244c.png";